<template>
    <div data-test="prettySelectWrapper" class="pretty-select" :class="getColorClass">
        <label data-test="prettySelectLabel" v-if="this.value || this.alwaysShowPlaceholder">{{ localLabel }}</label>
        <v-select data-test="prettySelectSelect" ref="select" v-model="localValue" v-bind="selectProps" v-on="$listeners" v-if="enabled" :calculate-position="withPopper">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
            <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData"><slot :name="name" v-bind="slotData" /></template>
        </v-select>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import { createPopper } from '@popperjs/core'
export default {
    name: 'PrettySelect',
    components: { vSelect },
    props: {
        value: {
            default: null,
        },
        filterable: {
            default: true,
        },
        options: {
            default: null,
        },
        label: {
            default: null,
        },
        getOptionLabel: {
            default: undefined,
        },
        multiple: {
            default: null,
        },
        taggable: {
            default: null,
        },
        pushTags: {
            default: null,
        },
        reduce: {
            default: undefined,
        },
        placeholder: {
            default: null,
        },
        required: {
            default: undefined,
        },
        filterBy: {
            default: undefined,
        },
        disabled: {
            default: false,
        },
        getOptionKey: {
            default: undefined,
        },
        selectOnTab: {
            default: true,
        },
        appendToBody: {
            default: true,
        },
        clearable: {
            default: true,
        },
        alwaysShowPlaceholder: {
            default: false,
        },
        customPlaceholder: {
            default: null,
        },
        preventTextWrap: {
            default: false,
        },
        color: {},
    },
    data () {
        return {
            enabled: true,
        }
    },

    computed: {
        localLabel () {
            if (typeof this.required !== 'undefined') {
                return this.required !== false ? `${this.placeholder} *` : `${this.placeholder}`
            }

            return this.placeholder
        },
        localPlaceholder () {
            const placeholder = this.customPlaceholder || this.placeholder
            if (typeof this.required !== 'undefined') {
                return this.required !== false ? `${placeholder} *` : `${placeholder}`
            }

            return placeholder
        },
        selectProps () {
            return {
                ...this.$props,
                placeholder: this.localPlaceholder,
            }
        },
        localValue: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value)
            },
        },
        getColorClass () {
            let classes = ''

            if (this.preventTextWrap) {
                classes += 'pretty-select--no-wrap '
            }

            if (this.color) {
                classes += `pretty-select--${this.color}`
            }

            return classes
        },
    },
    methods: {
        withPopper (dropdownList, component, { width }) {
            dropdownList.style.width = width

            const popper = createPopper(component.$refs.search, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [10, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn ({ state }) {
                            component.$el.classList.toggle('drop-up', state.placement === 'top')
                        },
                    },
                ],
            })

            return () => popper.destroy()
        },
        redraw () {
            this.enabled = false
            this.$nextTick(() => {
                this.enabled = true
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.pretty-select {
    position: relative;
}
</style>
